import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { whmcsCurrency } from '@app/core';
import { AuthState } from '@app/core/auth/states/auth.state';
import { AppState } from '@app/core/states/app.state';
import { LogEvent, SetEventProperties } from '@app/core/states/event-tracking.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { UiModule } from '@app/ui';
import { environment } from '@env/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PublishingPlatform } from '../../models/publishing.model';
import { PublishingState } from '../../states/publishing.state';

@Component({
  selector: 'rk-paid-publication-modal',
  imports: [FontAwesomeModule, TranslatePipe, UiModule, AsyncPipe],
  templateUrl: './paid-publication-modal.component.html',
  styleUrl: './paid-publication-modal.component.scss',
})
export class PaidPublicationModalComponent implements OnInit, OnDestroy {
  currency$: Observable<whmcsCurrency> = inject(Store).select(AuthState.userCurrency);
  currentAppIdPlan$: Observable<number> = inject(Store).select(
    AppConfigurationState.currentAppIdPlan,
  );
  noIosPublishingData$: Observable<boolean> = inject(Store).select(
    PublishingState.noIosPublishingData,
  );
  selectedPlatform: PublishingPlatform = null;
  private readonly subscriptions = new Subscription();
  private readonly store = inject(Store);
  private readonly dialogRef = inject(MatDialogRef<PaidPublicationModalComponent>);
  currencyMappig = {
    EUR: '€',
    USD: '$',
    GBP: '£',
  };

  addOnPrice: string;

  ngOnInit() {
    this.subscriptions.add(
      this.currency$.subscribe(currency => {
        this.addOnPrice = `50${this.currencyMappig[currency]}`;
      }),
    );

    this.subscriptions.add(
      this.noIosPublishingData$.subscribe(noIos => {
        if (noIos) {
          this.selectedPlatform = 'android';
        } else {
          return;
        }
      }),
    );

    this.store.dispatch(
      new SetEventProperties({
        name: 'ModalPaidPublishingAddon',
        component: 'ModalPaidPublishingAddon',
      }),
    );

    this.store.dispatch(new LogEvent('Modal Viewed'));
  }

  onClose(): void {
    this.dialogRef.close();

    // tracking
    this.store.dispatch(
      new SetEventProperties({
        name: `ButtonCancelPurchase`,
        component: 'ModalPaidPublishingAddon',
      }),
    );
    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  onSelectPlatform(platform: PublishingPlatform) {
    this.selectedPlatform = platform;
  }

  onBuyAddon(platform: 'android' | 'ios') {
    const serviceId = this.store.selectSnapshot(AppState.currentAppServiceId);
    const aid =
      platform === 'android'
        ? environment.whmcs.updateAddonId.android
        : environment.whmcs.updateAddonId.ios;
    window.open(
      `${environment.whmcs.url}/cart.php?a=add&aid=${aid}&productid=${serviceId}`,
      '_blank',
    );
    this.dialogRef.close();
    // tracking
    this.store.dispatch(
      new SetEventProperties({
        name: `ButtonAddToCart`,
        component: 'ModalPaidPublishingAddon',
      }),
    );
    this.store.dispatch(new LogEvent('Button Clicked'));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
